<div class="p-grid p-responsive p-fluid">
    <ng-container *ngIf="isMultiSelect && !isPopUp">
        <ng-container *ngIf="selectAllRequired">
            <p-multiSelect [options]="options | dropdownSort:orderBy" optionLabel="{{label}}"
                [maxSelectedLabels]="maxSelectedLabels" [(ngModel)]="value" [disabled]="disabled"
                defaultLabel="{{defaultLabel}}" (onChange)="change()" (onBlur)="blur()"
                [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly" [showClear]="true"
               [appendTo]="'body'">
                <ng-template let-option pTemplate="item" *ngIf="useCustomTemplate">
                    <span>{{option.label}}</span>
                    <div [innerHTML]="getHtml( option.value.descrLong)" class="text-smaller"></div>
                </ng-template>
            </p-multiSelect>
        </ng-container>
        
        <ng-container  *ngIf="!selectAllRequired">

            <p-multiSelect [options]="options | dropdownSort:orderBy" optionLabel="{{label}}"
                [maxSelectedLabels]="maxSelectedLabels" [(ngModel)]="value" [disabled]="disabled"
                defaultLabel="{{defaultLabel}}" (onChange)="change()" (onBlur)="blur()"
                [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly" [showClear]="true"
                [selectionLimit]="limitTo" [appendTo]="'body'">
                <ng-template let-option pTemplate="item" *ngIf="useCustomTemplate">
                    <span>{{option.label}}</span>
                    <div [innerHTML]="getHtml( option.value.descrLong)" class="text-smaller"></div>
                </ng-template>
            </p-multiSelect>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="isMultiSelect && isPopUp">
        <ng-container  *ngIf="!selectAllRequired">
        <p-multiSelect [options]="options | dropdownSort:orderBy" optionLabel="{{label}}"
            [maxSelectedLabels]="maxSelectedLabels" [(ngModel)]="value" [disabled]="disabled"
            defaultLabel="{{defaultLabel}}" (onChange)="change()" (onBlur)="blur()"
            [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly" [showClear]="true" [selectionLimit]="limitTo"
            [contentStyle]="{'overflow':'visible'}">
            <ng-template let-option pTemplate="item" *ngIf="useCustomTemplate">
                <span>{{option.label}}</span>
                <div [innerHTML]="getHtml( option.value.descrLong)" class="text-smaller"></div>
            </ng-template>
        </p-multiSelect>
        </ng-container>
        <ng-container  *ngIf="selectAllRequired">
            <p-multiSelect [options]="options | dropdownSort:orderBy" optionLabel="{{label}}"
                [maxSelectedLabels]="maxSelectedLabels" [(ngModel)]="value" [disabled]="disabled"
                defaultLabel="{{defaultLabel}}" (onChange)="change()" (onBlur)="blur()"
                [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly" [showClear]="true"
                [contentStyle]="{'overflow':'visible'}">
                <ng-template let-option pTemplate="item" *ngIf="useCustomTemplate">
                    <span>{{option.label}}</span>
                    <div [innerHTML]="getHtml( option.value.descrLong)" class="text-smaller"></div>
                </ng-template>
            </p-multiSelect>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!isMultiSelect && !useCustomTemplate && !group">
        <div [ngSwitch]="true">
            <div *ngSwitchCase="options?.length > 50 && isPopUp">
                <p-dropdown [options]="options | dropdownSort:orderBy:reverse" optionLabel="{{label}}"
                    [(ngModel)]="value" [filter]="true" [disabled]="disabled" placeholder="{{defaultLabel}}"
                    (onChange)="change()" (onBlur)="blur()" [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly"
                    [virtualScroll]="true" [itemSize]="30" [resetFilterOnHide]="true" [showClear]="true"
                    [contentStyle]="{'overflow':'visible'}">
                </p-dropdown>
            </div>
            <div *ngSwitchCase="options?.length < 50 && isPopUp">
                <p-dropdown [options]="options | dropdownSort:orderBy:reverse" optionLabel="{{label}}"
                    [(ngModel)]="value" [filter]="true" [disabled]="disabled" placeholder="{{defaultLabel}}"
                    (onChange)="change()" (onBlur)="blur()" [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly"
                    [resetFilterOnHide]="true" [showClear]="true" [tooltip]="getTooltipDescr()"
                    [contentStyle]="{'overflow':'visible'}">
                </p-dropdown>
            </div>
            <div *ngSwitchCase="options?.length > 50 && !isPopUp">
                <p-dropdown [options]="options | dropdownSort:orderBy:reverse" optionLabel="{{label}}"
                    [(ngModel)]="value" [filter]="true" [disabled]="disabled" placeholder="{{defaultLabel}}"
                    (onChange)="change()" (onBlur)="blur()" [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly"
                    [itemSize]="40" [resetFilterOnHide]="true" [showClear]=showClear
                    [appendTo]="'body'">
                </p-dropdown>
            </div>
            <div *ngSwitchDefault>
                <p-dropdown [options]="options | dropdownSort:orderBy:reverse" optionLabel="{{label}}"
                    [(ngModel)]="value" [filter]="true" [disabled]="disabled" placeholder="{{defaultLabel}}"
                    (onChange)="change()" (onBlur)="blur()" [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly"
                    [resetFilterOnHide]="true" [showClear]=showClear [tooltip]="getTooltipDescr()" [appendTo]="'body'">
                </p-dropdown>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!isMultiSelect && useCustomTemplate">
        <p-dropdown [options]="options | dropdownSort:orderBy" optionLabel="{{label}}" [(ngModel)]="value"
            [filter]="true" [disabled]="disabled" placeholder="{{defaultLabel}}" (onChange)="change()" (onBlur)="blur()"
            [ngClass]="{'is-invalid': isInvalid}" [readonly]="readOnly" [resetFilterOnHide]="true" [showClear]="true">
            <ng-template let-option pTemplate="item">
                <div>{{option.descr}}</div>
                <div [innerHTML]="getHtml( option.descrLong)" class="text-muted text-smaller"></div>
            </ng-template>
        </p-dropdown>
    </ng-container>
    <ng-container *ngIf="group">
        <p-dropdown [options]="groupedOptions" [group]="group" [filter]="true" [(ngModel)]="value" [disabled]="disabled"
            placeholder="{{defaultLabel}}" (onChange)="change()" (onBlur)="blur()" [ngClass]="{'is-invalid': isInvalid}"
            [readonly]="readOnly" [resetFilterOnHide]="true" [showClear]="true">
            <ng-template let-item pTemplate="selectedItem">
                <span>{{item.value}} - {{item.label}}</span>
            </ng-template>
            <ng-template let-group pTemplate="group">
                <span>{{group.label}}</span>
            </ng-template>
            <ng-template let-item pTemplate="item">
                <span>{{item.value}} - {{item.label}}</span>
            </ng-template>
        </p-dropdown>
    </ng-container>
</div>